import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

interface ProtectedRouteProps {
  component: React.ComponentType;
  allowedRoles: string[] | undefined;
  roleRedirects?: { [role: string]: string };
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, allowedRoles, roleRedirects = {} }) => {
  const { user, isRefreshing } = useAppSelector((state) => state.user);

  const location = useLocation();

  if (isRefreshing) {
    return <Component />;
  }

  if (!user || !user.role) {
    if (location.pathname === '/') {
      return <Component />;
    }
    return <Navigate to="/profile" replace />;
  }

  const userRedirect = roleRedirects[user.role];

  if (location.pathname === userRedirect) {
    return <Component />;
  }

  if (userRedirect) {
    return <Navigate to={userRedirect} state={{ from: location }} replace />;
  }

  if (!allowedRoles || allowedRoles.includes(user.role)) {
    return <Component />;
  }

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default ProtectedRoute;
